<template>
    <div class="alert alert-dismissible fade show" :class="messageSent ? 'alert-primary' : 'alert-danger'" role="alert">
        <strong>{{messageToDisplay.header}}</strong>&nbsp;{{messageToDisplay.body}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" 
            @click="showMessageStatus({shown: false})">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    computed: {
        ...mapState(['messageSent']),
        messageToDisplay: {
            get: function(){
                let message = {
                    header: '',
                    body: ''
                };

                if (this.messageSent){
                    message.header = 'Message sent!';
                    message.body = 'Thanks, I&quo;ll be in touch soon';
                }
                else {
                    message.header = 'Uh-oh!';
                    message.body = 'Sorry, currently unable to send your message';
                }

                return message;
            }
        }
    },
    methods: {
        ...mapActions(['showMessageStatus'])
    }
}
</script>

<style lang="scss" scoped>
.alert {
    border: 0;
    position: fixed;
    font-size: 0.8rem;
    top: 4.5rem;
    right: 0.5rem;
    z-index: 1031;

    &-danger {
        background-color: $colour-red;
        color: $colour-white;
    }

    button {
        font-size: 1.2rem;
    }
}
</style>
